import type { Metaobject } from "@shopify/hydrogen-react/storefront-api-types";

const usePreOrder = (preOrderData: Metaobject) => {
  const description = preOrderData.fields.find((item) => item.key === "description");
  const title = preOrderData.fields.find((item) => item.key === "title");
  const fulfillmentDate = preOrderData.fields.find((item) => item.key === "fulfillment_date");

  return {
    title: title?.value,
    fulfillmentDate: fulfillmentDate?.value,
    description: description?.value,
  };
};

export default usePreOrder;
